
const badge = {
  mounted(el: HTMLElement, binding: any) {
    const { value, modifiers } = binding;
    if (value) {
      let obj:any = {};
      if (modifiers.right) {
        obj.position = 'right';
      } else if (modifiers.topRight) {
        obj.position = 'topRight';
      }
      if (typeof value === 'string') {
        obj = Object.assign(obj, {
          show: true,
          text: value,
          version: 'v1'
        });
      } else {
        obj = {
          show: true,
          version: 'v1',
          ...obj,
          ...value
        };
      }
      el.classList.add(`cursor-badge-${obj.version}-${obj.position}`);
      el.dataset.content = obj.text;
    }
  }
};

export default badge;